import { FileSpreadsheet, Link2, Upload } from 'lucide-react'

import { SubTabShell, type SubTab } from '@/components/SubTabShell'

const SUBTABS: SubTab[] = [
  { path: '/main/quote',          label: '견적서 변환', Icon: Upload, matchExact: true, hint: '견적서 xls 업로드 → 거래처별 단가 등록' },
  { path: '/main/quote/mappings', label: '코드 매칭',   Icon: Link2,  hint: '견적서 원본코드 ↔ 품목코드 매핑 관리' },
]

export function QuoteShell() {
  return (
    <SubTabShell
      Icon={FileSpreadsheet}
      title="견적서 변환"
      subtitle="거래처 견적표 → 거래처별 단가 자동 등록"
      subtabs={SUBTABS}
    />
  )
}
